const primaryWhite = '#F8F9F8'
const mutedWhite = '#D6D7D6'
const brandGreen = '#2EB88A'
const brandGreenDark = '#228967'
const brandGreenSoft = '#8DE2C6'
const brandYellow = '#F6D600'
const brandPink = '#EB8398'
const background = '#2A2D2A'
const surface = '#3C403C'

module.exports = {
    nativeScrollbars: true,
    theme: {
        colors: {
            primary: {
                // headers (h2) and download button
                main: primaryWhite,
            },
            success: {
                // 200 Successful operation drop down and 200 text on button of Response samples 
                main: brandGreen,
            },
            error: {
                // required text under parameters 
                main: brandPink,
            },
            text: {
                // majority of all text in main center section and the bearerAuth table
                primary: primaryWhite,
                // prop text in center area
                secondary: mutedWhite,
            },
            http: {
                delete: brandPink,
                get: brandGreen,
                patch: brandYellow,
                put: brandYellow,
                post: brandGreenDark,
            },
        },
        schema: {
            linesColor: brandGreenSoft,
            typeTitleColor: brandGreenSoft,
        },
        typography: {
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeightBold: '600',
            headings: {
                fontFamily: 'Inter, sans-serif',
                fontWeight: '700',
            },
            links: {
                color: brandGreen,
                hover: brandGreenSoft,
                visited: brandGreen,
            }
        },
        sidebar: {
            backgroundColor: background,
            textColor: primaryWhite,
            activeTextColor: brandGreenSoft,
            fontSize: '14px',
            arrow: {
                size:'17px',
                color: primaryWhite,
            }
        },
        codeBlock: {
            backgroundColor: background,
        },
        logo: {
            maxHeight: '80%',
            maxWidth: '90%',
            gutter: '18px',
        }, 
        rightPanel: {
            backgroundColor: surface,
            width: '40%',
        },

    },
}
